/**
 * Search in lists. The same rule on the server (export of a filtered list) and in the pages: case, accents and the
 * special letters of German and Turkish do not matter (ä → a, ı → i, ß → ss), every word of the query must occur.
 */

/** Lower case without accents (ä -> a, ı -> i, ß -> ss). */
export function searchText(s: string): string {
  return s
    .toLowerCase()
    .replace(/ı/g, 'i')
    .replace(/ß/g, 'ss')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}

/** All words of the query occur in the text (any order). An empty query matches everything. */
export function matchesSearch(text: string, query: string): boolean {
  const q = searchText(query).trim();
  if (!q) return true;
  const t = searchText(text);
  return q.split(/\s+/).every((w) => t.includes(w));
}
